export default __webpack_public_path__ + "static/banner-finance-in-search-of-the-well-rounded-lifestyle-d5c1dbc6f7f580c407125aa49f1ef812.jpg";